import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { convertProductOptionsToUsableFormat } from 'components/consumer/PDP/helpers/pdpOptionUtils';
import useAllOptions from 'data-hooks/useAllOptions';
import usePDPQueryOptionsForProduct from './usePDPQueryOptionsForProduct';
const usePDPGetOptionsForProduct = (t0, t1) => {
  const $ = _c(16);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug,
    initialProductOptions
  } = t2;
  let t3;
  if ($[2] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    skip: t4
  } = t3;
  const skip = t4 === undefined ? false : t4;
  const {
    loading: allOptionValuesLoading,
    allOptionsValues,
    error: allOptionValuesError
  } = useAllOptions();
  const isAllOptionsLoading = allOptionValuesLoading && !allOptionsValues;
  let t5;
  if ($[4] !== initialProductOptions || $[5] !== slug) {
    t5 = {
      slug,
      initialProductOptions
    };
    $[4] = initialProductOptions;
    $[5] = slug;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== skip) {
    t6 = {
      skip
    };
    $[7] = skip;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const {
    loading: productOptionsLoading,
    error: productOptionsError,
    data: productOptionsData
  } = usePDPQueryOptionsForProduct(t5, t6);
  let t7;
  bb0: {
    if (!productOptionsData?.productOptions || !allOptionsValues) {
      t7 = null;
      break bb0;
    }
    let t8;
    if ($[9] !== allOptionsValues || $[10] !== productOptionsData) {
      t8 = convertProductOptionsToUsableFormat(productOptionsData, allOptionsValues);
      $[9] = allOptionsValues;
      $[10] = productOptionsData;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    const finalOptions = t8;
    t7 = finalOptions;
  }
  const productOptions = t7;
  const t8 = productOptionsLoading || isAllOptionsLoading;
  const t9 = productOptionsError || allOptionValuesError;
  let t10;
  if ($[12] !== productOptions || $[13] !== t8 || $[14] !== t9) {
    t10 = {
      data: productOptions,
      loading: t8,
      error: t9
    };
    $[12] = productOptions;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export default usePDPGetOptionsForProduct;